import { render, staticRenderFns } from "./LoginCompanyPage.vue?vue&type=template&id=1d1265c0"
import script from "./LoginCompanyPage.vue?vue&type=script&lang=ts"
export * from "./LoginCompanyPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginCompanyPage.vue?vue&type=style&index=0&id=1d1265c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports